export const OPEN_MAP_FILTERS_EVENT = "reelitpro:open-map-filters";
export const TOGGLE_MAP_LAYERS_EVENT = "reelitpro:toggle-map-layers";
export const TOGGLE_MAP_MEASURE_EVENT = "reelitpro:toggle-map-measure";
export const CLOSE_MAP_TOOLS_PANELS_EVENT = "reelitpro:close-map-tools-panels";
export const MAP_TOOLS_PANEL_STATE_EVENT = "reelitpro:map-tools-panel-state";
export const SUPPRESS_NEXT_MAP_TOOLS_TOGGLE_EVENT =
  "reelitpro:suppress-next-map-tools-toggle";
